// Context-aware greetings for different pages
export const getContextualGreeting = (pageContext, userName = '') => {
  const name = userName ? ` ${userName}` : '';
  
  const greetings = {
    home: `👋 Hi${name}! I'm Brad's AI assistant.\n\nI can help you with:\n• Understanding different coverage options\n• Getting started with your quote\n• Answering general insurance questions\n\nWhat can I help you with today?`,
    
    products: `👋 Hi${name}! I'm Brad's AI assistant.\n\nI can help you:\n• Compare different insurance products\n• Understand coverage differences\n• Choose what's right for you\n\nWhat questions do you have?`,
    
    'book-appointment': `👋 Hi${name}! I'm Brad's AI assistant.\n\nI can help you with:\n• Choosing the best appointment time\n• Answering coverage questions\n• Explaining what to expect in your consultation\n\nWhat can I help you with today?`,
    
    'thank-you': `🎉 Congratulations on completing your quote${name}!\n\nI'm here if you have questions about:\n• Your coverage details\n• Next steps in the process\n• Payment options\n\nHow can I assist you?`,
    
    'quote-results': `👋 Hi${name}! I'm Brad's AI assistant.\n\nI can help you:\n• Understand the different rate classes\n• Compare carrier options\n• Explain premium differences\n\nWhat would you like to know?`,
    
    about: `👋 Hi${name}! I'm Brad's AI assistant.\n\nI can help you with:\n• Learning about our services\n• Understanding our process\n• Answering any questions\n\nHow can I help?`,
    
    default: `👋 Hi${name}! I'm Brad's AI assistant. How can I help you today?`
  };

  return greetings[pageContext] || greetings.default;
};

// Quick action buttons based on page context
export const getQuickActions = (pageContext) => {
  const actions = {
    home: [
      { emoji: '📋', text: 'How does this work?', query: 'How does the insurance quote process work?' },
      { emoji: '💰', text: 'What coverage amounts?', query: 'What coverage amounts should I consider?' },
      { emoji: '⏱️', text: 'How long does it take?', query: 'How long does it take to get a quote?' }
    ],
    
    products: [
      { emoji: '🔍', text: 'Compare products', query: "What's the difference between these insurance products?" },
      { emoji: '💡', text: 'Which is best for me?', query: 'Which insurance product is best for my situation?' },
      { emoji: '📊', text: 'Coverage amounts', query: 'How much coverage do I need?' }
    ],
    
    'book-appointment': [
      { emoji: '📅', text: 'Consultation prep', query: 'What should I prepare for the consultation?' },
      { emoji: '💰', text: 'Coverage questions', query: 'What coverage options do you recommend?' },
      { emoji: '⏱️', text: 'Appointment length', query: 'How long will the appointment take?' }
    ],
    
    'thank-you': [
      { emoji: '📧', text: 'What happens next?', query: 'What are the next steps after submitting my quote?' },
      { emoji: '💳', text: 'Payment options', query: 'What payment options are available?' },
      { emoji: '📞', text: 'When will I be contacted?', query: 'When will someone contact me?' }
    ],
    
    'quote-results': [
      { emoji: '🏆', text: 'Best rate class?', query: 'What is the difference between rate classes?' },
      { emoji: '🔄', text: 'Why different prices?', query: 'Why are there different prices for each carrier?' },
      { emoji: '✅', text: 'How to apply', query: 'What happens after I click Apply?' }
    ],
    
    default: [
      { emoji: '❓', text: 'General question', query: 'I have a general question' },
      { emoji: '📞', text: 'Contact info', query: 'How can I contact someone?' },
      { emoji: '🏠', text: 'Start over', query: 'I want to start over' }
    ]
  };

  return actions[pageContext] || actions.default;
};

// Simulate AI response (would connect to real AI API in production)
export const generateAIResponse = (userMessage) => {
  // This is a placeholder - in production, you'd call your AI API here
  const lowerMessage = userMessage.toLowerCase();
  
  if (lowerMessage.includes('appointment') || lowerMessage.includes('consultation')) {
    return "Great question! Your consultation with Brad typically takes about 30-45 minutes. He'll review your coverage needs, answer your questions, and help you find the best insurance solution. You can schedule it at a time that works best for you!";
  }
  
  if (lowerMessage.includes('coverage') || lowerMessage.includes('amount')) {
    return "Coverage amounts typically range from $250,000 to $2,000,000+. A good rule of thumb is 10-12 times your annual income. Brad can help you determine the right amount during your consultation based on your specific needs and financial situation.";
  }
  
  if (lowerMessage.includes('price') || lowerMessage.includes('cost') || lowerMessage.includes('rate')) {
    return "Rates vary based on your age, health, coverage amount, and term length. Brad will help you find competitive rates from top carriers. During your consultation, he'll explain all the options and help you find the best value for your needs.";
  }
  
  if (lowerMessage.includes('long') || lowerMessage.includes('time') || lowerMessage.includes('take')) {
    return "The appointment typically takes 30-45 minutes. Brad will walk you through everything step by step, answer all your questions, and make sure you feel confident about your coverage decision. There's no rush!";
  }
  
  // Default response
  return "Thanks for your message! I'm an AI assistant designed to help answer your questions. In a production environment, I'd be connected to a real AI that understands your insurance needs. For now, Brad will get back to you shortly! Is there anything specific you'd like to know?";
};

